import { render } from "./ConfirmDaemonDeleteModal.vue?vue&type=template&id=4549fae6&scoped=true"
import script from "./ConfirmDaemonDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDaemonDeleteModal.vue?vue&type=script&lang=js"

import "./ConfirmDaemonDeleteModal.vue?vue&type=style&index=0&id=4549fae6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4549fae6"]])

export default __exports__